import b from 'b_';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './icon2.scss';

const cls = b.with('icon2');

const Icon2 = ({ children, mix, name, title, ...domProps }) => {
    return (
        <svg className={cx(cls(), cls(name), mix)} {...domProps}>
            {title ? <title>{title}</title> : null}
            {children}
        </svg>
    );
};

Icon2.displayName = 'Icon2';

Icon2.propTypes = {
    children: PropTypes.node.isRequired,
    mix: PropTypes.string,
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
};

export default Icon2;
